import { TextField } from '@mui/material';
import React from 'react';
import { AttachmentLink } from '../containers';
import { ETIAnswerV1 } from '../types';

export interface AnswerProps {
  answer?: ETIAnswerV1 | null;
}

const Answer = ({ answer }: AnswerProps) => {
  if (!answer || answer.questionType === 'text') {
    return (
      <TextField
        fullWidth
        multiline
        minRows={1}
        placeholder="Answer"
        id="answer"
        variant="standard"
        value={answer?.userAnswer}
        slotProps={{ input: { readOnly: true } }}
      />
    );
  }

  if (!!answer) {
    return <AttachmentLink attachmentKey={answer.userAnswer} />;
  }

  return <></>;
};

export default Answer;
